export const tools = {
  isNullOrUndefined: data => {
    try {
      return data !== "undefined";
    } catch (e) {
      return false;
    }
  }
};
